/** XP, levels and skill points (docs/game-design.md §2–4). */
export const PROGRESSION = {
  xp: {
    win: 100,
    loss: 40,
    draw: 60, // placeholder
    koBonus: 20,
    firstWinOfDay: 50,
    streakDays: 7,
    streakReward: 300,
    botFactor: 0.5,
    /** Share of XP when a game plan fought a league fight while the player was away. */
    leagueAwayFactor: 0.5,
  },

  /** Opponent strength multiplier on win XP, by rating difference (opponent − player). */
  opponentBands: [
    { maxDiff: -300, multiplier: 0.2, label: 'easy' },
    { maxDiff: -150, multiplier: 0.6, label: 'easy' },
    { maxDiff: 150, multiplier: 1, label: 'even' },
    { maxDiff: 300, multiplier: 1.2, label: 'tough' },
    { maxDiff: Infinity, multiplier: 1.4, label: 'tough' },
  ],

  /** Weekly budget: fight number this week (1-based) → share of fight XP. */
  weeklyBands: [
    { upTo: 40, factor: 1 },
    { upTo: 100, factor: 0.3 },
    { upTo: 200, factor: 0.1 },
    { upTo: Infinity, factor: 0 },
  ],

  rested: {
    /** Rested when last week had fewer fights than this. */
    lastWeekBelow: 20,
    fights: 20,
    factor: 2,
  },

  level: {
    max: 100,
    /** XP from level L to L + 1 = base + perLevel × L. */
    base: 300,
    perLevel: 30,
  },

  skillPoints: {
    /** XP for the next point = base + perPoint × points earned from XP so far. */
    base: 100,
    perPoint: 12,
    maxFromXp: 150,
    /** Coins instead of a point after the cap. */
    overflowCoins: 50, // placeholder
  },

  /** Build label: Balanced when no group has more than this share of spent points. */
  balancedShare: 0.35, // placeholder
} as const;
